// @TODO: Remove name and value props if not needed

import styled from "@emotion/styled";
import PropTypes from "prop-types";

import { capitalizeFirstLetter } from "@hmn/coolinarika-web-core/helpers";
import { useAnalytics } from "@hmn/coolinarika-web-core/hooks";

import { isNumeric } from "../../../../helpers/utils";
import { ConditionalWrapper } from "../../../ConditionalWrapper";
import { HtmlContent } from "../../../HtmlContent";
import { CloseHeavyIcon, Icon } from "../../../Icon";
import { Link } from "../../../Link";
import styles from "./Pill.style";

const PillStyled = styled.button((props) => ({ ...styles(props) }));

const pillVariants = Object.freeze({
    PRIMARY: "primary",
    SECONDARY: "secondary",
});

const Pill = ({
    className,
    label,
    value,
    name,
    id,
    count,
    onClick,
    href,
    hrefAs,
    isRounded,
    hasRemoveIcon,
    iconLeftAlign,
    hasSpacing,
    variant,
    isDishTag,
    ...rest
}) => {
    const { eventTracking: gaEventClick } = useAnalytics("coolinarika.itemClick", {
        elementCategory: "Tag",
        elementLabel: "General",
        elementPageLocation: "body",
        items: { tag: label },
    });

    if (!label) {
        return null;
    }

    const isClickable = typeof onClick === "function";
    const handleOnClick = (event) => {
        if (isClickable || href) {
            gaEventClick();
        }
        if (isClickable) {
            onClick(event);
        }
    };

    return (
        <ConditionalWrapper
            condition={!!href}
            Wrapper={Link}
            href={href}
            as={hrefAs}
            title={label}
            passHref
            noTag
        >
            <PillStyled
                as={href ? "a" : "button"}
                type={href ? undefined : "button"}
                onClick={handleOnClick}
                isClickable={isClickable || href}
                value={value}
                name={name}
                id={id}
                iconLeftAlign={iconLeftAlign}
                isRounded={isRounded}
                isDishTag={isDishTag}
                hasSpacing={hasSpacing}
                className={className}
                variant={variant}
                {...rest}
            >
                <span className="pill_label">
                    <HtmlContent content={capitalizeFirstLetter(label)} wrapperComponent="span" />
                    {isNumeric(count) && count > 0 && <span className="pill_count">({count})</span>}
                </span>
                {isClickable && hasRemoveIcon && (
                    <span className="pill_icon">
                        <Icon icon={CloseHeavyIcon} />
                    </span>
                )}
            </PillStyled>
        </ConditionalWrapper>
    );
};

Pill.propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onClick: PropTypes.func,
    href: PropTypes.string,
    hrefAs: PropTypes.string,
    isRounded: PropTypes.bool,
    hasRemoveIcon: PropTypes.bool,
    iconLeftAlign: PropTypes.bool,
    hasSpacing: PropTypes.bool,
    isDishTag: PropTypes.bool,
    variant: PropTypes.oneOf([...Object.values(pillVariants)]),
};

Pill.defaultProps = {
    className: undefined,
    label: undefined,
    value: undefined,
    name: undefined,
    id: undefined,
    count: undefined,
    onClick: undefined,
    href: undefined,
    hrefAs: undefined,
    isRounded: true,
    hasRemoveIcon: false,
    iconLeftAlign: false,
    hasSpacing: false,
    isDishTag: false,
    variant: pillVariants.PRIMARY,
};

export { pillVariants };

export default Pill;
